export default __webpack_public_path__ + "static/media/app_bingo.a4de38e6.png";